<template>
  <td
    class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400 dark:bg-gray-900 dark:border-gray-800 first-of-type:pl-4 last-of-type:pr-4 first-of-type:sm:pl-5 last-of-type:sm:pr-5"
  >
    <slot />
  </td>
</template>

<script setup lang="ts"></script>
